//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VisitCardSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/calendar/visit-card-settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.VisitCardSettingsDto, unknown, Types.VisitCardSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.VisitCardSettingsDto, unknown, Types.VisitCardSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VisitCardSettingsClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

/**
 * Gets visit card settings for current tenant.
 */
export function useGetQuery<TSelectData = Types.VisitCardSettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.VisitCardSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.VisitCardSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.VisitCardSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.VisitCardSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.VisitCardSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets visit card settings for current tenant.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.VisitCardSettingsDto | undefined) => Types.VisitCardSettingsDto, ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

/**
 * Gets visit card settings for current tenant.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.VisitCardSettingsDto | undefined) => Types.VisitCardSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(): string {
  let url_ = getBaseUrl() + "/api/calendar/visit-card-settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(): MutationKey {
  return trimArrayEnd([
      'VisitCardSettingsClient',
      'patch',
    ]);
}

/**
 * Patches visit card settings for current tenant.
 */
export function usePatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.VisitCardSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.VisitCardSettingsPatchDto, TContext> {
  const key = patchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.VisitCardSettingsPatchDto) => Client.patch(dto),
    mutationKey: key,
  });
}
  
export function resetToDefaultUrl(): string {
  let url_ = getBaseUrl() + "/api/calendar/visit-card-settings/reset-to-default";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetToDefaultMutationKey(): MutationKey {
  return trimArrayEnd([
      'VisitCardSettingsClient',
      'resetToDefault',
    ]);
}

/**
 * Reset default visit card settings for current tenant.
 */
export function useResetToDefaultMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetToDefaultMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetToDefault(),
    mutationKey: key,
  });
}